<app-dialog
  #dialog
  [key]="dialogKey"
  [action]="dialogKey"
  [headerTheme]="'simple'"
  [title]="config()?.title ?? ''"
  [appendTo]="'body'"
  [maxWidth]="'560px'"
  (onClose)="onDialogClosed()">
  @if (config(); as current) {
    <div class="reason" data-testid="dictionary-reason-dialog">
      <p class="reason__description">{{ current.description }}</p>
      <app-input
        [type]="'textarea'"
        [label]="current.label"
        [placeholder]="current.placeholder"
        [required]="true"
        [textCenter]="false"
        [maxLength]="maxLength()"
        [ngModel]="text()"
        (ngModelChange)="text.set($event ?? '')"
        data-testid="dictionary-reason-input" />
      <span class="reason__counter">{{ text().length }} / {{ maxLength() }}</span>
    </div>
  }

  <ng-template #footer>
    <div class="reason__footer">
      <app-button
        [label]="'Cancelar'"
        [theme]="'white'"
        [type]="'button'"
        (sendButtonClick)="close()" />
      <app-button
        [label]="config()?.confirmLabel ?? 'Confirmar'"
        [theme]="config()?.confirmTheme ?? 'default'"
        [type]="'button'"
        [disabled]="!isFormValid()"
        data-testid="dictionary-reason-confirm"
        (sendButtonClick)="submitAction()" />
    </div>
  </ng-template>
</app-dialog>
